import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';
import { difference, sortBy } from 'lodash-es';
import { AntavoService } from '../../../module/antavo/antavo.service';
import { NAntavo } from '../../../module/antavo/antavo.interface';
import { PwaAccountBackComponent } from '../common/back/pwa-account-back.component';
import { PwaMissionComponent } from '../common/mission/pwa-mission.component';
export namespace NAccountMissions {
    export const componentId = 'account-missions';

    export interface IAccountMissionsContent {
        title?: string;
        subtitle?: string;
        completedMissionsTitle?: string;
        noMissionsTitle?: string;
        noMissionsSubtitle?: string;
    }
}

@Component({
    selector: 'account-missions',
    templateUrl: './account-missions.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, PwaAccountBackComponent, ICmsClientModule, PwaMissionComponent, RouterModule]
})
@ICmsComponent<AccountMissionsComponent>({
    id: NAccountMissions.componentId,
    block: {
        url: NAccountMissions.componentId
    },
    onDemandOnly: true,
    name: 'Account Missions',
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            default: 'Account'
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'subtitle',
            title: 'Subtitle',
            default: 'My Missions'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'completedMissionsTitle',
            title: 'Completed Missions Title',
            default: 'Completed Missions:'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'noMissionsTitle',
            title: 'No Missions Title',
            default: 'Empty Missions'
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'noMissionsSubtitle',
            title: 'No Missions subtitle',
            default: "We don't have any missions for you yet."
        }
    ]
})
export class AccountMissionsComponent extends UiComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NAccountMissions.IAccountMissionsContent;

    protected completedMissions: NAntavo.IChallenge[] = [];
    protected inProgressMissions: NAntavo.IChallenge[] = [];
    private route = inject(ActivatedRoute);
    private antavoService = inject(AntavoService);

    override ngOnInit() {
        super.ngOnInit();
        const challengesResponse = this.route.snapshot.data['missions'] as NAntavo.IChallengesResponse | undefined;
        if (challengesResponse?.payload) {
            // Separate completed and in-progress missions
            const completedMissions = challengesResponse.payload?.filter((challenge: NAntavo.IChallenge) =>
                this.antavoService.isMissionCompleted(challenge)
            );
            const inProgressMissions = difference(challengesResponse.payload, completedMissions);

            // Sort both arrays by tag-based sort order
            this.completedMissions = sortBy(completedMissions, (mission: NAntavo.IChallenge) =>
                this.antavoService.getMissionSortOrder(mission.tags)
            );
            this.inProgressMissions = sortBy(inProgressMissions, (mission: NAntavo.IChallenge) =>
                this.antavoService.getMissionSortOrder(mission.tags)
            );
        }
    }
}
